import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation, useQueryClient } from '@tanstack/vue-query'

export const useSearchPresetDelete = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (id: number) => http.del(`/search/presets/${id}`),
  })

  const remove = async (id: number) => {
    try {
      await mutation.mutateAsync(id)

      addSuccess(trs('itf.deleted_preset'))

      await queryClient.invalidateQueries({ queryKey: ['load_search_presrts'] })
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    remove,
  }
}
